export default "__VITE_ASSET__Dx9mg3b2__"